// extracted by mini-css-extract-plugin
module.exports = {"container":"Locatie_container__Jsusg layouts_container__1HB9_","kaart":"Locatie_kaart__22kXd"};